"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionText = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const ui_common_translation_1 = require("@desygner/ui-common-translation");
const { rem } = ui_common_components_1.utils;
const StyledSectionTextContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  cursor: pointer;

  ${({ theme }) => (0, styled_components_1.css) `
    padding: ${rem(theme.Spacing.Size.Small)} ${rem(theme.Spacing.Size.XSmall)};
    gap: ${rem(theme.Spacing.Size.Small)};
  `}
`;
const StyledCardContainer = styled_components_1.default.div `
  width: 100%;
`;
function SectionText({ onUpdate, options, onSectionClose, }) {
    const { t } = (0, ui_common_translation_1.useTranslation)();
    const handleTextSelect = (0, react_1.useCallback)((data) => {
        onUpdate(data);
        onSectionClose(false);
    }, [onSectionClose, onUpdate]);
    //On this return, we should look at the facade and look at this function: getClickElementData and addElement
    // to see how it manage the creation and the size of this for us
    return ((0, jsx_runtime_1.jsx)(StyledSectionTextContainer, { children: options.map((text, index) => ((0, jsx_runtime_1.jsx)(StyledCardContainer, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Card, { onClick: () => handleTextSelect({
                    content: text.content,
                    fontFamily: text.fontFamily,
                    fontSize: text.fontSize,
                    size: text.size,
                }), children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: text.type, children: t(text.titleKey) }) }) }, index))) }));
}
exports.SectionText = SectionText;
//# sourceMappingURL=SectionText.js.map